<script setup lang="ts">
import { EditPencil } from "@iconoir/vue";
import { type RouterLinkProps } from "vue-router";
import IconButtonLink from "./IconButtonLink.vue";

defineProps<RouterLinkProps>();
</script>

<template>
  <IconButtonLink v-bind="$props" alt="Bearbeiten">
    <EditPencil />
  </IconButtonLink>
</template>
